<template>
  <v-form
    v-if="mapeamento"
    ref="form"
    v-model="valid"
    @submit.prevent="onSubmit"
  >
    <v-row no-gutters>
      <v-col cols="12">
        <app-title :texto="titulo" />
      </v-col>
    </v-row>
    <v-row>
      <!-- Importação e seleção das unidades -->
      <v-col
        v-if="
          (mapeamento.mapeamentoImportado &&
            mapeamento.tipoImportacaoMapeamento) ||
            !isEdicaoBloqueada
        "
        cols="12"
      >
        <v-card
          flat
          outlined
        >
          <v-card-title class="subtitle-1 primary--text">
            Importar Mapeamento
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-chip
                  v-if="
                    mapeamento.mapeamentoImportado &&
                      mapeamento.tipoImportacaoMapeamento
                  "
                  color="success"
                  text-color="white"
                  :close="!isEdicaoBloqueada"
                  @click:close="removeImportacao"
                >
                  {{ mapeamento.mapeamentoImportado.nome }} -
                  {{ mapeamento.tipoImportacaoMapeamento.nome }}
                </v-chip>
                <v-tooltip
                  v-else-if="!isEdicaoBloqueada"
                  top
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      dark
                      text
                      @click="toogleDialogImportacao"
                      v-on="on"
                    >
                      Adicionar
                      <v-icon class="ml-2">
                        add_circle
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Clique para adicionar um mapeamento</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card
          flat
          outlined
        >
          <v-card-title class="subtitle-1 primary--text">
            Unidade Principal
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-autocomplete
                  v-model="mapeamento.unidade"
                  :items="unidadesOrdenadasPorSigla"
                  :item-text="getUnidadeSiglaAndNome"
                  label="Unidade principal"
                  placeholder="Digite para pesquisar..."
                  :rules="[(v) => !!v || 'Selecione a unidade']"
                  :disabled="
                    isEdicaoBloqueada || mapeamento.mapeamentoImportado !== null
                  "
                  prepend-icon="search"
                  auto-select-first
                  clearable
                  chips
                  deletable-chips
                  return-object
                >
                  <template v-slot:selection="data">
                    <v-chip
                      color="primary"
                      text-color="white"
                      :close="
                        !isEdicaoBloqueada &&
                          mapeamento.mapeamentoImportado === null
                      "
                      class="chip--select-multi"
                      @click:close="mapeamento.unidade = null"
                    >
                      {{ `${data.item.sigla} - ${data.item.nome}` }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card
          class="overflow-y-auto"
          max-height="400"
          flat
          outlined
        >
          <v-card-title class="subtitle-1 primary--text">
            Unidades Vinculadas ({{
              mapeamento.unidades.length
            }}
            selecionada(s))
          </v-card-title>
          <v-card-subtitle
            v-if="mapeamento.unidade && mapeamento.unidades.length === 0"
          >
            Selecione ao menos uma unidade vinculada
          </v-card-subtitle>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <v-tooltip top>
                  <template v-slot:activator="{ on: onTooltip }">
                    <v-checkbox
                      v-show="subunidades.length > 0"
                      v-model="selectAllItens"
                      :disabled="isEdicaoBloqueada"
                      label="Selecionar Todas"
                      color="secondary"
                      class="ml-4"
                      @change="toggleItens"
                      v-on="{ ...onTooltip }"
                    />
                  </template>
                  <span>Clique para selecionar todas as unidades vinculadas</span>
                </v-tooltip>
                <v-treeview
                  v-model="mapeamento.unidades"
                  :items="unidadesTreeview"
                  selection-type="independent"
                  selected-color="secondary"
                  item-disabled="bloqueado"
                  dense
                  open-all
                  selectable
                  open-on-click
                  return-object
                >
                  <template v-slot:label="{ item }">
                    {{ `${item.sigla} - ${item.nome}` }}
                    <v-chip
                      v-if="item.importado"
                      color="success"
                      class="ml-2"
                      outlined
                      small
                    >
                      Mapeada
                    </v-chip>
                    <v-spacer />
                  </template>
                </v-treeview>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Nome e ano do mapeamento -->
      <v-col
        cols="12"
        sm="9"
      >
        <v-text-field
          id="nome"
          v-model.trim="mapeamento.nome"
          color="primary"
          label="Nome"
          prepend-icon="library_books"
          required
          disabled
        />
      </v-col>
      <v-col
        cols="12"
        sm="3"
      >
        <app-year-select
          v-model="mapeamento.ano"
          :rules="[(v) => v >= anoAtual || 'Selecione um ano atual']"
          :desabilitado="isEdicaoBloqueada"
        />
      </v-col>
    </v-row>

    <!-- Seleção de datas das etapas comportamentais -->
    <v-row>
      <v-col
        v-if="mapeamento.inicioPerComportServidor !== null"
        cols="12"
        md="6"
      >
        <v-card
          flat
          outlined
        >
          <v-card-title class="subtitle-1 primary--text">
            Cadastro dos Comportamentos
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col
                cols="12"
                sm="6"
              >
                <app-date-select
                  label="Data Inicial"
                  tooltip="Data inicial para cadastrar os comportamentos"
                  :data-inicial="mapeamento.inicioPerComportServidor"
                  :rules="[...rulesDataInicial, ...rulesMinDataDiagnostico]"
                  :min="minInicioPerComportServidor"
                  :max="maxInicioPerComportServidor"
                  :desabilitado="
                    isDataDesabilitada(mapeamento.inicioPerComportServidor)
                  "
                  @return="
                    (value) => (mapeamento.inicioPerComportServidor = value)
                  "
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <app-date-select
                  label="Data Final"
                  tooltip="Data final para cadastrar os comportamentos"
                  :data-inicial="mapeamento.fimPerComportServidor"
                  :rules="[...rulesDataFinal, ...rulesMinDataDiagnostico]"
                  :min="minFimPerComportServidor"
                  :max="maxFimPerComportServidor"
                  :desabilitado="
                    mapeamento.inicioPerComportServidor === '' ||
                      isDataDesabilitada(mapeamento.fimPerComportServidor)
                  "
                  @return="
                    (value) => (mapeamento.fimPerComportServidor = value)
                  "
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-card
          flat
          outlined
        >
          <v-card-title class="subtitle-1 primary--text">
            Normalização dos Comportamentos
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col
                cols="12"
                sm="6"
              >
                <app-date-select
                  label="Data Inicial"
                  tooltip="Data inicial para normalizar os comportamentos cadastrados"
                  :data-inicial="mapeamento.inicioPerComportComissao"
                  :rules="[...rulesDataInicial, ...rulesMinDataDiagnostico]"
                  :min="minInicioPerComportComissao"
                  :max="maxInicioPerComportComissao"
                  :desabilitado="
                    mapeamento.inicioPerComportServidor === '' ||
                      mapeamento.fimPerComportServidor === '' ||
                      isDataDesabilitada(mapeamento.inicioPerComportComissao)
                  "
                  @return="
                    (value) => (mapeamento.inicioPerComportComissao = value)
                  "
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <app-date-select
                  label="Data Final"
                  tooltip="Data final para normalizar os comportamentos cadastrados"
                  :data-inicial="mapeamento.fimPerComportComissao"
                  :rules="[...rulesDataFinal, ...rulesMinDataDiagnostico]"
                  :min="minFimPerComportComissao"
                  :max="maxFimPerComportComissao"
                  :desabilitado="
                    mapeamento.inicioPerComportComissao === '' ||
                      isDataDesabilitada(mapeamento.fimPerComportComissao)
                  "
                  @return="
                    (value) => (mapeamento.fimPerComportComissao = value)
                  "
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Seleção de datas das etapas técnicas -->
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-card
          flat
          outlined
        >
          <v-card-title class="subtitle-1 primary--text">
            Cadastro das Responsabilidades
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col
                cols="12"
                sm="6"
              >
                <app-date-select
                  label="Data Inicial"
                  tooltip="Data inicial para cadastrar as responsabilidades"
                  :data-inicial="mapeamento.inicioPerRespGestor"
                  :rules="[...rulesDataInicial, ...rulesMinDataDiagnostico]"
                  :min="minInicioPerRespGestor"
                  :max="maxInicioPerRespGestor"
                  :desabilitado="
                    isDataDesabilitada(mapeamento.inicioPerRespGestor)
                  "
                  @return="(value) => (mapeamento.inicioPerRespGestor = value)"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <app-date-select
                  label="Data Final"
                  tooltip="Data final para cadastrar as responsabilidades"
                  :data-inicial="mapeamento.fimPerRespGestor"
                  :rules="[...rulesDataFinal, ...rulesMinDataDiagnostico]"
                  :min="minFimPerRespGestor"
                  :max="maxFimPerRespGestor"
                  :desabilitado="
                    mapeamento.inicioPerRespGestor === '' ||
                      isDataDesabilitada(mapeamento.fimPerRespGestor)
                  "
                  @return="(value) => (mapeamento.fimPerRespGestor = value)"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-card
          flat
          outlined
        >
          <v-card-title class="subtitle-1 primary--text">
            Normalização das Responsabilidades
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col
                cols="12"
                sm="6"
              >
                <app-date-select
                  label="Data Inicial"
                  tooltip="Data inicial para normalizar as responsabilidades"
                  :data-inicial="mapeamento.inicioPerRespCom"
                  :rules="[...rulesDataInicial, ...rulesMinDataDiagnostico]"
                  :min="minInicioPerRespCom"
                  :max="maxInicioPerRespCom"
                  :desabilitado="
                    mapeamento.inicioPerRespGestor === '' ||
                      mapeamento.fimPerRespGestor === '' ||
                      isDataDesabilitada(mapeamento.inicioPerRespCom)
                  "
                  @return="(value) => (mapeamento.inicioPerRespCom = value)"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <app-date-select
                  label="Data Final"
                  tooltip="Data final para normalizar as responsabilidades"
                  :data-inicial="mapeamento.fimPerRespCom"
                  :rules="[...rulesDataFinal, ...rulesMinDataDiagnostico]"
                  :min="minFimPerRespCom"
                  :max="maxFimPerRespCom"
                  :desabilitado="
                    mapeamento.inicioPerRespCom === '' ||
                      isDataDesabilitada(mapeamento.fimPerRespCom)
                  "
                  @return="(value) => (mapeamento.fimPerRespCom = value)"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-card
          flat
          outlined
        >
          <v-card-title class="subtitle-1 primary--text">
            Validação das Responsabilidades
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col
                cols="12"
                sm="6"
              >
                <app-date-select
                  label="Data Inicial"
                  tooltip="Data inicial para validar as responsabilidades"
                  :data-inicial="mapeamento.inicioPerRespChefiaSuperior"
                  :rules="[...rulesDataInicial, ...rulesMinDataDiagnostico]"
                  :min="minInicioPerRespChefiaSuperior"
                  :max="maxInicioPerRespChefiaSuperior"
                  :desabilitado="
                    mapeamento.fimPerRespCom === '' ||
                      isDataDesabilitada(mapeamento.inicioPerRespChefiaSuperior)
                  "
                  @return="
                    (value) => (mapeamento.inicioPerRespChefiaSuperior = value)
                  "
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <app-date-select
                  label="Data Final"
                  tooltip="Data final para validar as responsabilidades"
                  :data-inicial="mapeamento.fimPerRespChefiaSuperior"
                  :rules="[...rulesDataFinal, ...rulesMinDataDiagnostico]"
                  :min="minFimPerRespChefiaSuperior"
                  :max="maxFimPerRespChefiaSuperior"
                  :desabilitado="
                    mapeamento.inicioPerRespChefiaSuperior === '' ||
                      isDataDesabilitada(mapeamento.fimPerRespChefiaSuperior)
                  "
                  @return="
                    (value) => (mapeamento.fimPerRespChefiaSuperior = value)
                  "
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-card
          flat
          outlined
        >
          <v-card-title class="subtitle-1 primary--text">
            Consolidação das Responsabilidades
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col
                cols="12"
                sm="6"
              >
                <app-date-select
                  label="Data Inicial"
                  tooltip="Data inicial para consolidar as responsabilidades"
                  :data-inicial="mapeamento.inicioPerRespConsol"
                  :rules="[...rulesDataInicial, ...rulesMinDataDiagnostico]"
                  :min="minInicioPerRespConsol"
                  :max="maxInicioPerRespConsol"
                  :desabilitado="
                    mapeamento.inicioPerRespChefiaSuperior === '' ||
                      mapeamento.fimPerRespChefiaSuperior === '' ||
                      isDataDesabilitada(mapeamento.inicioPerRespConsol)
                  "
                  @return="(value) => (mapeamento.inicioPerRespConsol = value)"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <app-date-select
                  label="Data Final"
                  tooltip="Data final para consolidar as responsabilidades"
                  :data-inicial="mapeamento.fimPerRespConsol"
                  :rules="[...rulesDataFinal, ...rulesMinDataDiagnostico]"
                  :min="minFimPerRespConsol"
                  :max="maxFimPerRespConsol"
                  :desabilitado="
                    mapeamento.inicioPerRespConsol === '' ||
                      isDataDesabilitada(mapeamento.fimPerRespConsol)
                  "
                  @return="(value) => (mapeamento.fimPerRespConsol = value)"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="justify-end">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            :disabled="!valid || mapeamento.unidades.length === 0"
            color="primary"
            class="mr-2"
            type="submit"
            v-on="on"
          >
            {{ isEdicao ? "Editar" : "Cadastrar" }}
          </v-btn>
        </template>
        <span>Clique no botão para {{ isEdicao ? "editar" : "salvar" }} o
          mapeamento</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            :disabled="!formUpdated"
            color="primary"
            outlined
            class="mr-3"
            @click="reset"
            v-on="on"
          >
            Cancelar
          </v-btn>
        </template>
        <span>Clique no botão para cancelar
          {{ isEdicao ? "a edição" : "o cadastro" }} do mapeamento</span>
      </v-tooltip>
    </v-row>

    <importacao-mapeamento
      :visibilidade="isImportacao"
      :toogle="toogleDialogImportacao"
      @import="(value) => addImportacao(value)"
    />

    <dialog-info :value="aviso" />
  </v-form>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import AppTitle from '@/components/core/AppTitle';
import AppYearSelect from '@/components/core/AppYearSelect';
import AppDateSelect from '@/components/core/AppDateSelect';
import ImportacaoMapeamento from '@/components/mapeamento/ImportacaoMapeamento';
import DialogInfo from '@/components/DialogInfo';
import Data from '@/modules/data';

const mapeamentoRepository = RepositoryFactory.get('mapeamento');

export default {
  name: 'MapeamentoForm',

  components: {
    AppTitle,
    AppYearSelect,
    AppDateSelect,
    ImportacaoMapeamento,
    DialogInfo,
  },

  props: {
    mapeamento: {
      type: Object,
      default: () => ({
        id: null,
        nome: '',
        ano: Data.get().year(),
        inicioPerComportServidor: '',
        fimPerComportServidor: '',
        inicioPerComportComissao: '',
        fimPerComportComissao: '',
        inicioPerRespGestor: '',
        fimPerRespGestor: '',
        inicioPerRespCom: '',
        fimPerRespCom: '',
        inicioPerRespChefiaSuperior: '',
        fimPerRespChefiaSuperior: '',
        inicioPerRespConsol: '',
        fimPerRespConsol: '',
        mapeamentoImportado: null,
        tipoImportacaoMapeamento: null,
        unidade: null,
        unidades: [],
      }),
      required: false,
    },
    isEdicao: {
      type: Boolean,
      default: false,
      required: false,
    },
    resetForm: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data() {
    return {
      valid: true,
      isImportacao: false,
      rulesDataInicial: [(v) => !!v.valor || 'Selecione a data inicial'],
      rulesDataFinal: [(v) => !!v.valor || 'Selecione a data final'],
      rulesMinDataDiagnostico: [
        (v) => !this.minDataDiagnostico
          || Data.compare('isBefore', { a: v.valor, b: this.minDataDiagnostico })
          || `A data não pode ser maior ou igual à data de início do diagnóstico (${Data.format(
            this.minDataDiagnostico,
          )})`,
      ],
      subunidades: [],
      isTodasUnidadesSelecionadas: false,
      defaultMapeamento: {
        id: null,
        nome: '',
        ano: Data.get().year(),
        inicioPerComportServidor: '',
        fimPerComportServidor: '',
        inicioPerComportComissao: '',
        fimPerComportComissao: '',
        inicioPerRespGestor: '',
        fimPerRespGestor: '',
        inicioPerRespCom: '',
        fimPerRespCom: '',
        inicioPerRespChefiaSuperior: '',
        fimPerRespChefiaSuperior: '',
        inicioPerRespConsol: '',
        fimPerRespConsol: '',
        mapeamentoImportado: null,
        tipoImportacaoMapeamento: null,
        unidade: null,
        unidades: [],
      },
      unidadesImportacao: [],
      unidadesImportacaoInativas: [],
      dialogInfo: {
        mensagem: '',
        visibilidade: false,
      },
    };
  },

  computed: {
    ...mapState({
      diagnosticos: (state) => state.diagnostico.diagnosticosComissao,
      unidadeDoUsuario: (state) => state.auth.unidade,
      unidades: (state) => state.unidade.unidades.filter((u) => u.ativa),
      mapeamentosComissao: (state) => state.mapeamento.mapeamentosComissao,
      mapeamentos: (state) => state.mapeamento.mapeamentos,
      usuariosMapeamentos: (state) => state.mapeamento.usuariosMapeamentos,
      aviso: (state) => state.app.aviso,
    }),
    unidadesOrdenadasPorSigla() {
      return this.unidades.slice().sort((a, b) => a.sigla.localeCompare(b.sigla));
    },
    titulo() {
      return this.isEdicao ? 'EDIÇÃO DE MAPEAMENTO' : 'CADASTRO DE MAPEAMENTO';
    },
    dataAtual() {
      return Data.get('YYYY-MM-DD');
    },
    anoAtual() {
      return Data.get().year();
    },
    minDataDiagnostico() {
      let minData = '';
      if (this.isEdicao) {
        const diagnosticos = this.diagnosticos.filter((d) => d.mapeamento.id === this.mapeamento.id);
        diagnosticos.forEach((d) => {
          let min;
          if (Data.compare('isBefore', { a: d.inicioComportamental, b: d.inicioResponsabilidadeChefia })) {
            min = d.inicioComportamental;
          } else {
            min = d.inicioResponsabilidadeChefia;
          }

          if (minData.trim() === '' || Data.compare('isBefore', { a: min, b: minData })) {
            minData = min;
          }
        });
      }
      return minData;
    },
    minInicioPerComportServidor() {
      return this.dataAtual;
    },
    maxInicioPerComportServidor() {
      if (this.mapeamento.fimPerComportServidor) {
        return this.mapeamento.fimPerComportServidor;
      }
      return this.subtrairDias(this.mapeamento.inicioPerComportComissao, 1);
    },
    minFimPerComportServidor() {
      return this.mapeamento.inicioPerComportServidor === ''
        ? this.dataAtual
        : this.mapeamento.inicioPerComportServidor;
    },
    maxFimPerComportServidor() {
      return this.subtrairDias(this.mapeamento.inicioPerComportComissao, 1);
    },
    minInicioPerComportComissao() {
      if (this.mapeamento.inicioPerComportServidor === null) {
        return this.dataAtual;
      }
      return this.somarDias(this.mapeamento.fimPerComportServidor, 1);
    },
    maxInicioPerComportComissao() {
      return this.mapeamento.fimPerComportComissao;
    },
    minFimPerComportComissao() {
      return this.mapeamento.inicioPerComportComissao === ''
        ? this.somarDias(this.mapeamento.fimPerComportServidor, 1)
        : this.mapeamento.inicioPerComportComissao;
    },
    maxFimPerComportComissao() {
      return this.subtrairDias(this.minDataDiagnostico, 1);
    },
    minInicioPerRespGestor() {
      return this.dataAtual;
    },
    maxInicioPerRespGestor() {
      return this.mapeamento.fimPerRespGestor;
    },
    minFimPerRespGestor() {
      return this.mapeamento.inicioPerRespGestor === '' ? this.dataAtual : this.mapeamento.inicioPerRespGestor;
    },
    maxFimPerRespGestor() {
      return this.subtrairDias(this.mapeamento.inicioPerRespCom, 1);
    },
    minInicioPerRespCom() {
      return this.somarDias(this.mapeamento.fimPerRespGestor, 1);
    },
    maxInicioPerRespCom() {
      return this.mapeamento.fimPerRespCom;
    },
    minFimPerRespCom() {
      return this.mapeamento.inicioPerRespCom === ''
        ? this.somarDias(this.mapeamento.fimPerRespGestor, 1)
        : this.mapeamento.inicioPerRespCom;
    },
    maxFimPerRespCom() {
      return this.subtrairDias(this.mapeamento.inicioPerRespChefiaSuperior, 1);
    },
    minInicioPerRespChefiaSuperior() {
      return this.somarDias(this.mapeamento.fimPerRespCom, 1);
    },
    maxInicioPerRespChefiaSuperior() {
      return this.mapeamento.fimPerRespChefiaSuperior;
    },
    minFimPerRespChefiaSuperior() {
      return this.mapeamento.inicioPerRespChefiaSuperior === ''
        ? this.somarDias(this.mapeamento.fimPerRespCom, 1)
        : this.mapeamento.inicioPerRespChefiaSuperior;
    },
    maxFimPerRespChefiaSuperior() {
      return this.subtrairDias(this.mapeamento.inicioPerRespConsol, 1);
    },
    minInicioPerRespConsol() {
      return this.somarDias(this.mapeamento.fimPerRespChefiaSuperior, 1);
    },
    maxInicioPerRespConsol() {
      return this.mapeamento.fimPerRespConsol;
    },
    minFimPerRespConsol() {
      return this.mapeamento.inicioPerRespConsol === ''
        ? this.somarDias(this.mapeamento.fimPerRespChefiaSuperior, 1)
        : this.mapeamento.inicioPerRespConsol;
    },
    maxFimPerRespConsol() {
      return this.subtrairDias(this.minDataDiagnostico, 1);
    },
    isEdicaoBloqueada() {
      return this.isEdicao && this.mapeamento.situacao && this.mapeamento.situacao.id !== 'AGENDADO';
    },
    unidadesTreeview() {
      const { unidade } = this.mapeamento;
      if (unidade) {
        const unidadesFilhas = _.uniq(_.flatten(this.subunidades.map((u) => u.subunidades)));
        const unidadesNos = this.subunidades.filter((u) => !unidadesFilhas.some((s) => s.id === u.id));
        const treeveiw = unidadesNos.map((s) => this.getArvore(s.id, this.subunidades));
        this.sortArvore({ filhos: treeveiw });
        return treeveiw;
      }
      return [];
    },
    selectAllItens: {
      get() {
        return this.mapeamento.unidades.length === this.subunidades.length;
      },
      set(value) {
        this.isTodasUnidadesSelecionadas = value;
      },
    },
    formUpdated() {
      return JSON.stringify(this.mapeamento) !== JSON.stringify(this.defaultMapeamento);
    },
  },

  watch: {
    'mapeamento.unidade': function (value) {
      if (value) {
        const unidade = value;
        const subunidades = this.getSubunidades(unidade.id);

        this.mapeamento.nome = `${this.mapeamento.ano} ${unidade.sigla}`;

        if (this.mapeamento.mapeamentoImportado) {
          this.mapeamento.unidades = this.isEdicao
            ? this.mapeamento.mapeamentoImportado.unidades
            : this.unidadesImportacao;
        } else if (!this.isEdicao) {
          this.mapeamento.unidades = [];
        }
        this.subunidades = subunidades.filter((u) => u.id !== unidade.id);
      } else {
        this.mapeamento.nome = '';
        this.mapeamento.unidades = [];
        this.subunidades = [];
      }
    },
    'mapeamento.unidades': function (value) {
      if (this.mapeamento.mapeamentoImportado) {
        let unidadesImportacaoSelecionadas;
        if (this.isEdicao) {
          unidadesImportacaoSelecionadas = this.mapeamento.mapeamentoImportado.unidades
            .some((u) => value.some((u2) => u2.id === u.id));
        } else {
          unidadesImportacaoSelecionadas = this.unidadesImportacao.some((u) => value.some((u2) => u2.id === u.id));
        }
        if (!unidadesImportacaoSelecionadas) {
          this.mapeamento.mapeamentoImportado = null;
          this.mapeamento.tipoImportacaoMapeamento = null;
          this.removeImportacaoArvore(this.unidadesTreeview);
        }
      }
    },
    'mapeamento.ano': function (value) {
      if (this.mapeamento.unidade) {
        this.mapeamento.nome = `${value} ${this.mapeamento.unidade.sigla}`;
      } else {
        this.mapeamento.nome = '';
      }
    },
    resetForm() {
      this.reset();
    },
  },

  methods: {
    onSubmit() {
      if (this.isEdicao) {
        mapeamentoRepository.update(this.mapeamento).then((response) => {
          const mapeamento = response.data;
          const idxComissao = this.mapeamentosComissao.findIndex((m) => m.id === mapeamento.id);
          if (idxComissao !== -1) {
            this.mapeamentosComissao.splice(idxComissao, 1, mapeamento);

            if (this.isMapeamentoContemUnidade(mapeamento, this.unidadeDoUsuario)) {
              const idx = this.mapeamentos.findIndex((m) => m.id === mapeamento.id);
              if (idx !== -1) {
                this.mapeamentos.splice(idx, 1, mapeamento);
              }
            }

            this.reset();
            this.$store.dispatch('app/success', {
              response,
              message: 'Mapeamento editado com sucesso!',
            });
          }
        });
      } else {
        mapeamentoRepository.create(this.mapeamento).then((response) => {
          const mapeamento = response.data;
          this.mapeamentosComissao.push(mapeamento);

          if (this.isMapeamentoContemUnidade(mapeamento, this.unidadeDoUsuario)) {
            this.usuariosMapeamentos.push(mapeamento.usuario);
            this.mapeamentos.push(mapeamento);
          }

          this.reset();
          this.$store.dispatch('app/success', {
            response,
            message: 'Mapeamento cadastrado com sucesso!',
          });
        });
      }
    },
    isMapeamentoContemUnidade(mapeamento, unidade) {
      return mapeamento.unidade.id === unidade.id || mapeamento.unidades.some((u) => u.id === unidade.id);
    },
    reset() {
      if (this.isEdicao || this.resetForm) {
        this.$emit('updating', false);
        this.$emit('resetForm', false);
      }
      this.$refs.form.resetValidation();
      this.$emit('mapeamento', { ...this.defaultMapeamento });
    },
    addImportacao(importacao) {
      if (!importacao.mapeamento.unidade.ativa) {
        this.$store.dispatch('app/error', {
          message: `Não foi possível importar os dados de mapeamento, pois a unidade ${
            importacao.mapeamento.unidade.sigla} está inativa`,
        });
      } else {
        this.mapeamento.mapeamentoImportado = importacao.mapeamento;
        this.unidadesImportacao = importacao.unidadesAtivas;
        this.unidadesImportacaoInativas = importacao.unidadesInativas;
        this.mapeamento.unidade = importacao.mapeamento.unidade;
        this.mapeamento.tipoImportacaoMapeamento = importacao.tipoImportacaoMapeamento;
        if (
          this.mapeamento.tipoImportacaoMapeamento
          && this.mapeamento.tipoImportacaoMapeamento.id === 'IMPORTAR_COMPORTAMENTAL_E_TECNICO'
        ) {
          this.mapeamento.inicioPerComportServidor = null;
          this.mapeamento.fimPerComportServidor = null;
        }
        if (this.unidadesImportacaoInativas.length > 0) {
          this.$store.dispatch('app/setAviso', {
            texto: 'Não foi possível importar os dados de mapeamento para as unidades '
              + `${this.unidadesImportacaoInativas.map((u) => u.sigla).join(', ')} porque elas estão inativas`,
            visibilidade: true,
          });
        }
      }
      this.toogleDialogImportacao();
    },
    removeImportacao() {
      if (
        this.mapeamento.tipoImportacaoMapeamento
        && this.mapeamento.tipoImportacaoMapeamento.id === 'IMPORTAR_COMPORTAMENTAL_E_TECNICO'
      ) {
        this.mapeamento.inicioPerComportServidor = '';
        this.mapeamento.fimPerComportServidor = '';
      }
      this.mapeamento.mapeamentoImportado = null;
      this.mapeamento.tipoImportacaoMapeamento = null;
      this.removeImportacaoArvore(this.unidadesTreeview);
    },
    toogleDialogImportacao() {
      this.isImportacao = !this.isImportacao;
    },
    getArvore(unidadeNoId, unidades) {
      const unidade = unidades.find((u) => u.id === unidadeNoId);
      let importado;
      if (this.isEdicao && this.mapeamento.mapeamentoImportado) {
        importado = this.mapeamento.mapeamentoImportado.unidades.some((u2) => u2.id === unidade.id);
      } else {
        importado = this.unidadesImportacao.some((u2) => u2.id === unidade.id);
      }
      if (unidade && unidade.subunidades.length > 0) {
        return {
          id: unidade.id,
          nome: unidade.nome,
          sigla: unidade.sigla,
          ativa: unidade.ativa,
          importado,
          bloqueado: this.isEdicaoBloqueada,
          children: unidade.subunidades.map((s) => this.getArvore(s.id, unidades)),
        };
      }
      return {
        id: unidade.id,
        nome: unidade.nome,
        sigla: unidade.sigla,
        ativa: unidade.ativa,
        importado,
        bloqueado: this.isEdicaoBloqueada,
        children: [],
      };
    },
    sortArvore(arvore) {
      if (arvore.children) {
        arvore.children.sort((a, b) => a.sigla.localeCompare(b.sigla));
        arvore.children.forEach((f) => this.sortArvore(f));
      }
    },
    removeImportacaoArvore(arvore) {
      arvore.forEach((no) => {
        no.importado = false;
        no.bloqueado = false;
        if (no.children && no.children.length > 0) {
          no.children.forEach((no2) => {
            this.removeImportacaoArvore([no2]);
          });
        }
      });
    },
    getSubunidades(unidadeId, acumulador = []) {
      const unidade = this.unidades.find((u) => u.id === unidadeId);
      if (unidade) {
        acumulador.push(unidade);
        if (unidade && unidade.subunidades.length > 0) {
          unidade.subunidades.forEach((s) => this.getSubunidades(s.id, acumulador));
        }
      }
      return acumulador;
    },
    getUnidadeSiglaAndNome(item) {
      return `${item.sigla} - ${item.nome}`;
    },
    toggleItens() {
      this.$nextTick(() => {
        if (this.selectAllItens) {
          this.mapeamento.unidades = [];
        } else {
          this.mapeamento.unidades = this.subunidades;
        }
      });
    },
    somarDias(data, dias) {
      if (data && dias) {
        return Data.create(data).add(dias, 'days').format('YYYY-MM-DD');
      }
    },
    subtrairDias(data, dias) {
      if (data && dias) {
        return Data.create(data).subtract(dias, 'days').format('YYYY-MM-DD');
      }
    },
    isDataDesabilitada(data) {
      if (Data.compare('isValid', { a: data })) {
        return this.isEdicaoBloqueada && Data.compare('isAfter', { b: data });
      }
      return false;
    },
  },
};
</script>
